import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./blogPageStyles.css";
import { useNavigate } from 'react-router-dom';

const AntenatalCareContent = () => {
  const navigate = useNavigate(); 
  return (
    <>
      <Header />
       <div style={{
          padding: '30px', width: '100%', background: '#fff', paddingTop: "100px" }}>
           <button
             style={{
               marginTop: '20px',
               padding: '0px 20px',
               fontSize: '20px', 
               fontWeight: "bolder",
               backgroundColor: '#2196f3',
               color: '#fff',
               border: 'none',
               borderRadius: '8px',
               cursor: 'pointer',
             }}
             onClick={() => navigate('/blogs')} 
           >
             ⬅
           </button>
          <div className='fullContenth1'>
          <h1>Antenatal Care (Prenatal Care): What Is It and Why Does It Matter?</h1>
           <img
             src="/Blog1.png"
             alt="Antenatal Care"
             style={{
               width: '600px',
               maxHeight: '700px',
               objectFit: 'cover',
               borderRadius: '12px',
               margin: '20px auto',
               display: 'block',
             }}
           />
          </div>
          <p className='fullContentp'>Are you a mom-to-be? That’s wonderful news! But along with this joy comes a big sense of
                                    responsibility. Every month till the 9th is not easy to deal with, as at each stage you feel something new
                                    you have never felt. There's a lot to look forward to, think upon, and remember along the way. However,
                                    you're not alone in this.</p>
          <h2 className='fullContenth2'>From conception to childbirth, every mother keeps thinking — Is everything okay with the baby?</h2>
          <p className='fullContentp'>This is where antenatal care (also called prenatal care) comes in. This is a structured, absolute approach
                                      that keeps you and your baby healthy throughout the nine months.</p>
          <p className='fullContentp'>Want to learn more? Here is this magical guide, bringing all the answers to you, so you don't have to turn
               to Google every time a query comes in.<br></br>
               Let’s dive in!</p>
          <h2 className='fullContenth2'>Prenatal Care And Its Importance</h2>
          <p className='fullContentp'>Antenatal care, also known as prenatal care, is as simple as having someone by your side all the time,
              throughout your pregnancy journey. Yes, moms, it’s not just about the routine check-ups you plan for,
              but the comprehensive care you need during those days.
          </p>
          <p className='fullContentp'>Routine visits majorly help you avert possible medical issues like gestational diabetes, preeclampsia, or
                                      anemia, and more, so you and your baby stay healthy and safe. Besides, it keeps a close eye on your
                                      baby’s growth while preventing challenges like IUGR or macrosomia that may intricate delivery later on
                                      </p>
          <p className='fullContentp'>But apart from the medical side, antenatal care also takes care of your emotional needs. It offers you
                                       space to clear out your queries and doubts, share your worries, and feel backed up every step of the
                                       way. With little guidance on staying active and healthy, it even improves your chances of a smooth,
                                       normal delivery. And as you get ready to meet your little one, antenatal care helps you step into
                                       motherhood feeling all informed, confident, and ready, whether it’s getting a head start on breastfeeding
                                       or looking after your mental health in those precious early weeks. Well, after knowing the importance of
                                       antenatal care, you can’t deny how it's surely a gift you give to yourself and the baby.
                                       </p>



          <h2 className='fullContenth2'>What Does Prenatal Care Include?</h2>
          <p className='fullContentp'>It involves:</p>
          <ul className='fullContentlist'>
            <li>● Regular Doctor Consultations – Observe fetal growth, maternal vitals, and keep a check on
                  pregnancy progress.</li>
            <li>● Ultrasound Scans – Monitor your baby’s development at key stages.</li>
            <li>● Blood Tests & Diagnostics – Determine early signs of conditions like anemia, gestational
                  diabetes, or thyroid imbalances.</li>
            <li>● Nutrition Counselling– A personalized pregnancy diet to meet your and your baby’s developing
                  needs.</li>
            <li>● Mental Health – Stress, anxiety, mood swings— sure are normal during, but must be catered to.</li>
            <li>● Garbhasanskar – Rooted in the tradition of India, garbhasanskar during pregnancy fosters
                  emotional well-being and positivity during pregnancy.</li>
            <li>● Yoga (Prenatal) – Improves flexibility, decreases discomfort, and prepares the mom for
                  childbirth.</li>
            <li>● Lactation Advice– Helps you get ready for breastfeeding before the baby arrives.</li>
            <li>● Regular Health Check– Monitor blood pressure, sugar levels, fetal movements, and more
                  consistently.</li>
          </ul>

          <h2 className='fullContenth2'>The Problem with Today’s Antenatal Care</h2>
          <p className='fullContentp'>Even if we know how important pregnancy care is, many moms-to-be in India still face challenges—care
                                  scattered across various clinics and labs, no real focus on nutritional support or emotional needs, and no
                                  easy way to check daily changes that might signal something’s off. Besides the rise in hospital bills, along
                                  with the C-section rates, a packed schedule makes pregnancy an overwhelming journey. Even loved ones
                                  often don’t know how to pitch in. If this is what you are also feeling, you're not alone—and it’s exactly
                                  why Myprega came into life: to offer you integrated tech-driven pregnancy care, make your pregnancy
                                  journey simpler, safer, and fully supported, every step of the way.
                                  </p>
           <img
             src="/Blog1A.png"
             alt="Antenatal Care"
             style={{
               width: '600px',
               maxHeight: '700px',
               objectFit: 'cover',
               borderRadius: '12px',
               margin: '20px auto',
               display: 'block',
             }}
           />


          <h2 className='fullContenth2'>How Myprega Solves These Problems</h2>
          <p className='fullContentp'>Imagine a pregnancy journey where everything you need—medical guidance, emotional support, expert
                                advice—is just a tap away. That’s what Myprega brings to you. With a seamless mix of in-clinic care and
                                virtual sessions like yoga, Garbhasanskar, and nutrition, you’re supported both physically and
                                emotionally. Daily health tracking powered by AI keeps a close eye on you and your baby, alerting you
                                early if something needs attention. From gynecologists to mental health experts, lactation counselors to
                                dietitians, you have an entire team backing you. No hidden costs, no last-minute surprises—just clear,
                                convenient care, even from the comfort of your home. With Myprega, your buddy in pregnancy care in
                                India, you’re never alone. This is the kind of care every mom-to-be deserves.
                                </p>

          <h2 className='fullContenth2'>Warm Note</h2>
          <p className='fullContentp'>We understand that every mom deserves a pregnancy filled with delight, not stress. From the moment
                                   you have seen those two pink lines, Myprega is here to walk beside you, taking care of your mental
                                   health during pregnancy, making every step healthier, easier, and offering you all the support you truly
                                   need</p>

          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#2196f3',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            onClick={() => navigate('/blogs')} 
          >
            ← Back to Blogs
          </button>
        </div>
      <Footer />
    </>
  );
};

export default AntenatalCareContent;

